import Vue from "vue";
import Vuex from "vuex";
import axios from 'axios';
import {API_URL_A,CONTENT_DOMAIN,LOCAL_HOST,SESSION_TIME,FORM_ACTION_DOMAIN,HC_SITE_KEY,RTL_LANG,EXP_HUB_API} from '@/constants/general_constants';
import { functionMixins } from "./mixin/functionMixins";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentTheme:"",//ThemeCool ThemeMDB,ThemeVueMaterial , ThemeEngage , ThemeCool, ThemeScale
    languageId:'001',
    //companyData:[],
    companyData:{
      'id_company':localStorage.id_company,
      'id_eap':localStorage.id_eap,
      'id_country':localStorage.id_country,
      'id_language':localStorage.id_language,
      'id_service':localStorage.id_service,
      'id_service_actual':localStorage.id_service_actual,
      'id_service_link':localStorage.id_service_link,
      'custom_text_1':localStorage.custom_text_1,
      'custom_text_2':localStorage.custom_text_2,
      'custom_text_3':localStorage.custom_text_3,
      'custom_text_4':localStorage.custom_text_4,
      'custom_text_5':localStorage.custom_text_5,
      'encrypt_key':localStorage.encrypt_key,
      'name_company':localStorage.name_company,
      'login_user':localStorage.login_user,
      'id_session':localStorage.id_session},
    menuVar:[],
    languageFile:[],
    languageData:[],
   // menuUrl: 'http://localhost:3000/menu',
    apiUrl:API_URL_A,
    CONTENT_DOMAIN:CONTENT_DOMAIN,
    FORM_ACTION_DOMAIN:FORM_ACTION_DOMAIN,
    SESSION_TIME:SESSION_TIME,
    LOCAL_HOST:LOCAL_HOST,
    themeLogic:[],
    themeLogicFlag:false,
    hideLiveConnectfloat:'live-connect-cs',
    hideSchedulerfloat:'scheduler-cs',
    companyDataInfo:[],
    logoutFlag:0,
    moduleImage:[],
    directContentFlag:0,
    HC_SITE_KEY:HC_SITE_KEY,
    RTL_LANG:RTL_LANG,
    cosmicMenu:[],
    UCMSCompanyId:'',
    EXP_HUB_API:EXP_HUB_API
  },
  mutations: {
    setMenuVar(state,payload){
      state.menuVar=payload;
    },
    setCompanyData(state,payload){
      state.companyData=payload;
    },
    setTheme (state, payload) {
      state.currentTheme = payload
    },
    setLanguage (state, payload) {
      state.languageId = payload
    },
    setLanguageData (state, payload) {
      state.languageData = payload
    },
    setThemeLogic (state, payload) {
      state.themeLogic = payload
    },    
    setCompanyDataInfo (state, payload) {

      if(payload !== undefined) {
        state.companyDataInfo = payload
        //state.companyDataInfo.push(payload);
      } else {
        state.companyDataInfo = [];
      }
      //state.companyDataInfo = payload
    },
    setModuleImage(state, payload){
      state.moduleImage=payload;
    },
    setCosmicMenu(state,payload){
      state.cosmicMenu=payload;
    }
    

  },
  actions: {
    /*state function to get and set Main menu content*/
    async getMenu({state,commit},plan){
      //alert(this.get_api_key_mix('menu'))
      var md5 = require('md5')
      var api_private_key=md5(state.companyData['encrypt_key']+'menu')
      var id_svc=state.companyData['id_service_actual']
      try{
        //console.log('testenv'+process.env.VUE_APP_ROOT_API);
          let response=await axios.get(state.apiUrl+'/menu',{
              params:{
                  id_language:state.companyData['id_language'],
                  id_service:id_svc,
                  id_company:state.companyData['id_company'],
                  id_country:state.companyData['id_country'],
                  privatekey:api_private_key
              }
          });         
          var tmp_array={}         
          var oredr=response.data.order;
          oredr.forEach(function(key){
            if(key){
              tmp_array[' '+key]=response.data[key]
            }
          })
          commit('setMenuVar',tmp_array);
          commit('setModuleImage',response.data.image_path);
          //commit('setMenuVar',response.data);
        }catch(error){
          commit('setMenuVar',[]);
          commit('setModuleImage',[]);
          functionMixins.methods.customErrorHandler(error.response.status,1);
         // this.methods.customErrorHandlerStore(error.response.status);
          //console.log(error.response.data);
          //console.log(error.response.headers);
      }
    },

    /*state function to get and set Company specific data*/
    async getCompany({state,commit},plan){
      try{
        //console.log('testenv'+process.env.VUE_APP_ROOT_API);
          let response=await axios.get(state.apiUrl+'/company',{
              params:{                  
                  id_language:state.companyData['id_language'],
                  id_service:state.companyData['id_service'],
                  id_service_link:'0'
              }
          });
          //console.log(response.data);
          commit('setCompanyData',response.data);
      }catch(error){
          commit('setCompanyData',[]);
      }
    },
    
    /*state function to get and set language specific terms*/
    async getLanguageTerms({state,commit},plan){
      
      /*logic to set serviceid*/
      var id_svc=state.companyData['id_service']
      if (state.companyData["id_service_link"] > '-1') {
        if (state.companyData['id_language'] === '001' || state.companyData['id_language'] === '003') {
          id_svc=state.companyData['id_service'] 
        }
        else {
          id_svc=state.companyData['id_service_link']
        }
      }
      state.companyData['id_service_actual']=id_svc;
      localStorage.id_service_actual=id_svc;
      /*end set service id */

      try{
        //console.log('testenv'+process.env.VUE_APP_ROOT_API);
          let response=await axios.get(state.apiUrl+'/language_terms',{
              params:{                  
                  id_language:state.companyData['id_language'],
                  id_company:state.companyData['id_company'],
                  id_country:state.companyData['id_country']
              }
          });
          //console.log(response.data);       
          commit('setLanguageData',response.data);
      }catch(error){
          /*let response=await axios.get(state.apiUrl+'/language_terms',{
            params:{
                id_language:state.companyData['id_language'],
                id_company:state.companyData['id_company'],
                id_country:state.companyData['id_country']
            }
          });
          commit('setLanguageData',response.data);*/
          functionMixins.methods.customErrorHandler(error.response.status,1);
      }
    },

    /*state function to get and set theme*/
    async getTheme({state,commit},plan){
      try{        
          let response=await axios.get(state.apiUrl+'/theme_select',{
              params:{                  
                  id_company:state.companyData['id_company']
              }
          });
          //console.log('console storejs',response.data.theme);
          commit('setTheme',response.data.theme);
         //commit('setTheme','ThemeWorld'); //ThemeMegazine,ThemeVueMaterial , ThemeEngage , ThemeCool, ThemeScale ThemeWow ThemeMDB
      }catch(error){
          commit('setTheme','');
      }
    },
    
    /*state function to get and set ThemeLogic*/
    async getThemeLogic({state,commit},plan){
      
      //var api_private_key=(this.get_api_key_mix('mage'))
      var md5 = require('md5')
      var api_private_key= md5(state.companyData['encrypt_key']+'mage')
      try{        
          let response=await axios.get(state.apiUrl+'/main_page',{
              params:{                  
                  id_company:state.companyData['id_company'],
                  id_language:state.companyData['id_language'],
                  privatekey:api_private_key
              }
          });
          //console.log('console storejs',response.data.headers.announcement);
          state.themeLogicFlag=true;
          commit('setThemeLogic',response.data);
          
      }catch(error){
       
          commit('setThemeLogic',[]);
          functionMixins.methods.customErrorHandler(error.response.status,1);
          
      }
    },
    /*state function to get and set Companydata and settings*/
    async getCompanyDataInfo({state,commit},plan){
      //var api_private_key=(this.get_api_key_mix('mage'))
      var md5 = require('md5')
      var api_private_key= md5(state.companyData['encrypt_key']+'cofo')
      try{
          let response=await axios.get(state.apiUrl+'/company_info',{
              params:{
                id_company:state.companyData['id_company'] ,
                id_language:state.companyData['id_language'],   
                id_country:state.companyData['id_country'],                  
                privatekey:api_private_key
              }
          });
          commit('setCompanyDataInfo');
          // console.log('console storejs',state.languageData['logo_banner']);
          if(state.languageData['logo_banner'] !== undefined && state.languageData['logo_banner'] != "" ){
            localStorage.company_logo=state.languageData['logo_banner'];
          }
          else{
            localStorage.company_logo=response.data.company_logo ;
          }
          //for banner
          if(state.languageData['logo_site'] !== undefined && state.languageData['logo_site'] != "" ){
            localStorage.company_banner=state.languageData['logo_site'];
          }
          else{
            localStorage.company_banner=response.data.company_banner ;
          }
          localStorage.ucms_company=response.data.ucms_company;
          localStorage.lang_abbrevation = response.data.lang_abbreviation;
          commit('setCompanyDataInfo',response.data);
          
          if(state.currentTheme=='ThemeCosmic'){
            this.dispatch('getCosmicMenu');
          }
          
      }catch(error){
          commit('setCompanyDataInfo');
          functionMixins.methods.customErrorHandler(error.response.status,1);
      }
    },
    /*state function to get and set cosmic Main menu content*/
    async getCosmicMenu({state,commit},plan){
      //alert(this.get_api_key_mix('menu'))
      var md5 = require('md5')
      var api_private_key=md5(state.companyData['encrypt_key']+'conu')
      var id_svc=state.companyData['id_service_actual']
      try{
        //console.log('testenv'+process.env.VUE_APP_ROOT_API);
          let response=await axios.get(state.apiUrl+'/cosmicmenu',{
              params:{
                  id_language:state.companyData['id_language'],
                  id_service:id_svc,
                  id_company:state.companyData['id_company'],
                  id_country:state.companyData['id_country'],
                  privatekey:api_private_key
              }
          });         
          /* var tmp_array={}         
          var oredr=response.data.order;
          oredr.forEach(function(key){
            if(key){
              tmp_array[' '+key]=response.data[key]
            }
          })
          commit('setMenuVar',tmp_array);
           */
          commit('setCosmicMenu',response.data);
        }catch(error){
          commit('setCosmicMenu',[]);
          functionMixins.methods.customErrorHandler(error.response.status,1);
         // this.methods.customErrorHandlerStore(error.response.status);
          //console.log(error.response.data);
          //console.log(error.response.headers);
      }
    },
    
  }
  
});